import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getCpgJobsRedirectUrl } from './jobsRedirect';

const JobsAppRedirect = (): null => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    window.location.replace(getCpgJobsRedirectUrl(pathname, search, hash));
  }, [pathname, search, hash]);

  return null;
};

export default JobsAppRedirect;
